import React from 'react';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import ToggleSwitch from '../../components/ToggleSwitch';

import * as S from './style';

function VotesController({
  votesLimit,
  handleVotesLimitToggled,
  handleVotesLimitChanged,
}) {
  return (
    <>
      <ToggleSwitch
        id="votes-limit-toggle"
        checked={!!votesLimit}
        onChange={handleVotesLimitToggled}
      >
        {!votesLimit ? 'No votes limit' : 'Limit votes per participant'}
      </ToggleSwitch>
      {votesLimit && (
        <S.SetVotesWrapper>
          <button type="button" onClick={() => handleVotesLimitChanged(-1)}>
            <AiOutlineMinus />
          </button>
          <span>{votesLimit} </span>
          <button type="button" onClick={() => handleVotesLimitChanged(1)}>
            <AiOutlinePlus />
          </button>
        </S.SetVotesWrapper>
      )}
    </>
  );
}

export default VotesController;
